<template>
  <div class="rate_container">
    <div class="header_title">
      <h1>DENTRION is trusted</h1>
      <h1>
        by dental professionals.
      </h1>
    </div>
    <div class="rate_content_container">
      <div class="rate_contents">
        <p>95.6<span>%</span></p>
        <div class="subText">Client Retention Rate</div>
      </div>
      <div class="rate_contents">
        <p>100M<span>+</span></p>
        <div class="subText">Cases Completed</div>
      </div>
      <div class="rate_contents">
        <p>103<span>%</span></p>
        <div class="subText">Growth Rate</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
/* 전체 컨테이너 스타일 */
.rate_container {
  padding: 60px 32px 0 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}
.rate_content_container {
  display: flex;
  flex-direction: column;
  gap: 80px;
}
/* 타이틀 컨테이너 스타일 */
.header_title {
  text-align: start;
  color: #fff;
  width: 100%;
  font-weight: 700;
}

.header_title h1 {
  font-size: 28px;
  font-weight: 900;
  line-height: 0.8;
}
.subText {
  color: #BBE0C7;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 128%; /* 20.48px */
  letter-spacing: -0.8px;
}
.rate_contents {
  color: #51C37E;
  display: flex;
  align-items: center;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  font-weight: 500;
}

.rate_contents > p {
  font-size: 56px;
  font-weight: 900;
}

.rate_contents > p > span {
  font-size: 40px;
  font-weight: 900;
}
</style>
